import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from '../../../util/reactIntl';
import { ExternalLink } from '../../../components';
import heroBg from '../../../assets/heroImage.png';

import css from './SectionHero.module.css';

// How many of the admin's instrument categories the hero offers as quick searches
const POPULAR_COUNT = 4;

const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </svg>
);

/**
 * The hero: the photo full-bleed under a dark green wash, the promise, a search for the
 * whole market, and the first of the admin's instrument categories as quick links.
 */
function SectionHero(props) {
  const { intl, onSearch } = props;
  const [keywords, setKeywords] = useState('');

  // The same categories as the circles below (content from the admin panel)
  const shopLinks = useSelector(state => state.content.shopLinks || []);
  const popular = shopLinks.slice(0, POPULAR_COUNT);

  const submit = event => {
    event.preventDefault();
    onSearch(keywords.trim());
  };

  return (
    <section className={css.hero}>
      <img
        className={css.heroImage}
        src={heroBg}
        alt={intl.formatMessage({ id: 'SectionHero.imageAlt' })}
      />
      <div className={css.overlay} aria-hidden="true" />
      <div className={css.staves} aria-hidden="true" />
      <div className={css.heroInner}>
        <div className={css.heroContent}>
          <p className={css.eyebrow}>
            <FormattedMessage id="SectionHero.eyebrow" />
          </p>
          <h1 className={css.heading}>
            <FormattedMessage id="SectionHero.title" values={{ br: <br /> }} />
          </h1>
          <p className={css.para}>
            <FormattedMessage id="SectionHero.description" />
          </p>
          <form role="search" className={css.search} onSubmit={submit}>
            <span className={css.searchIcon}>
              <SearchIcon />
            </span>
            <label htmlFor="hero-search" className={css.visuallyHidden}>
              <FormattedMessage id="SectionHero.searchLabel" />
            </label>
            <input
              id="hero-search"
              type="search"
              className={css.searchInput}
              value={keywords}
              onChange={e => setKeywords(e.target.value)}
              placeholder={intl.formatMessage({ id: 'SectionHero.searchPlaceholder' })}
            />
            <button
              type="submit"
              className={css.searchButton}
              aria-label={intl.formatMessage({ id: 'SectionHero.searchButton' })}
            >
              <span className={css.searchButtonIcon}>
                <SearchIcon />
              </span>
              <span className={css.searchButtonText}>
                <FormattedMessage id="SectionHero.searchButton" />
              </span>
            </button>
          </form>
          {popular.length ? (
            <div className={css.popular}>
              <span className={css.popularLabel}>
                <FormattedMessage id="SectionHero.popular" />
              </span>
              {popular.map((item, index) =>
                item.isExternal ? (
                  <ExternalLink key={item.id || index} href={item.url} className={css.chip}>
                    {item.title}
                  </ExternalLink>
                ) : (
                  <Link key={item.id || index} to={item.url} className={css.chip}>
                    {item.title}
                  </Link>
                )
              )}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}

export default SectionHero;
